import { z } from 'zod';
export const IdentityProviders = z.enum(['INSTAGRAM', 'TIKTOK']);
export const IdentitySchema = z.object({
    id: z.string(),
    provider: IdentityProviders,
    providerId: z.string(),
    handle: z.string(),
    email: z.string().optional(),
});
